<template>
  <transition name="fade">
    <div class="flex-wrap items-center justify-center flex" style="background-color: white; border-left: 5px lightgrey solid; transition: 0.5s">
      <h3 class="hidden-lg hidden-md hidden-xl">Verify {{ $starLabel | sentenceCase }}</h3>
      <video width="180" height="180" controls style="margin: 2rem;">
        <source :src="user.profile.onboarding_video_link" />
      </video>
      <h3 class="hidden-sm hidden-xs" style="flex: 1;">Verify {{ $starLabel | sentenceCase }}</h3>
      <div v-if="user.status === 'active'" class="margin-r-2 flex items-center justify-center flex-wrap">
        <ladda-button class="btn btn-primary margin-x-1" style="border: solid 2px #F77211; min-width: 180px;" :click="handleActivateUserCallback">Activate {{ $starLabel | sentenceCase }}</ladda-button>
        <ladda-button class="btn btn-primary-outline-simple margin-x-1 margin-y-1" style="min-width: 180px;" :click="handleDeleteVideoCallback">Delete Video</ladda-button>
      </div>
      <div class="spacer-x-3" v-else>
        <h3><i class="fa fa-check"></i> User notified</h3>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
import { notify } from 'utils'
export default {
  props: {
    user: {
      required: true
    }
  },
  methods: {
    ...mapActions('user', ['activateUser', 'deleteOnboardingVideo']),

    handleActivateUserCallback () {
      return this.activateUser({ id: this.user.id })
        .then((response) => {
          notify.success('User successfully activated.')
        })
    },

    handleDeleteVideoCallback () {
      return this.deleteOnboardingVideo({ id: this.user.id })
        .then((response) => {
          notify.success('Video successfully deleted.')
        })
    }
  }
}
</script>
